import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Injector,
  ViewChild,
  ElementRef,
  forwardRef,
  Renderer2,
  OnDestroy,
  Inject,
  Optional,
  NgZone,
  ChangeDetectorRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { format, parse } from 'date-fns';
import {
  Overlay,
  ConnectionPositionPair,
  OverlayRef,
  OverlayConfig,
} from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { AdDatePickerPopupComponent } from '../ad-date-picker-popup/ad-date-picker-popup.component';
import { DATE_PICKER_CONFIG_DATA } from '../date-picker-config-data';
import { BodyOverflowHiddenScrollStrategy } from '../../ad-common/body-overflow-hidden-scroll-strategy';

@Component({
  selector: 'ad-date-picker',
  templateUrl: './ad-date-picker.component.html',
  styleUrls: ['./ad-date-picker.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdDatePickerComponent),
      multi: true,
    },
  ],
})
export class AdDatePickerComponent
  implements OnInit, ControlValueAccessor, OnDestroy {
  @Input() format: string = 'yyyy/M/d';
  @Input() inputReadonly: boolean = false;
  @Output() onChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Input() disabled: boolean = false;
  //if true when the user changes the selectedDate by the NgModel outside that will emit the change event.
  @Input() isEmitChangeOutside: boolean = true;

  @Input("max") maxDate: Date | string;
  @Input("min") minDate: Date | string;
  inputText: string;
  eventRemoverList: any[] = [];
  popupEventRemover: any;
  addEventRemover(fun: any) {
    if (fun) {
      this.eventRemoverList.push(fun);
    }
  }

  runEventRemoverList() {
    this.eventRemoverList.forEach((r) => {
      if (r) {
        r();
      }
    });
  }
  _seletedDate: Date;
  set seletedDate(val: Date) {
    this._seletedDate = val;
    this.updateInputTextBySelectedDate(val);
    this.onChangeFun(val);
  }

  get seletedDate() {
    return this._seletedDate;
  }
  constructor(
    private overlay: Overlay,
    private injector: Injector,
    private renderer2: Renderer2,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    @Optional() @Inject(DATE_PICKER_CONFIG_DATA) private config: any
  ) {
    if (config) {
      this.format = config.format;
    }
  }

  updateInputTextBySelectedDate(val: Date) {
    if (val) {
      this.inputText = format(val, this.format);
    } else {
      this.inputText = "";
    }
  }

  //#region ngModel
  onChangeFun = (val: Date) => { };
  onTouchedFun = () => { };
  writeValue(obj: Date): void {
    this._seletedDate = obj;
    this.updateInputTextBySelectedDate(obj);
    if (this.isEmitChangeOutside) {
      this.emitChangeEvent(this.seletedDate);
    }
  }
  registerOnChange(fn: any): void {
    this.onChangeFun = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFun = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  //#endregion

  //#region Popup
  popupOverlayRef: OverlayRef;
  @ViewChild('input', { static: true, read: ElementRef })
  inputElement: ElementRef;
  private getPositions(): ConnectionPositionPair[] {
    return [
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 10,
      },
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
        offsetY: 10,
      },
      {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
        offsetY: -10,
      },
      {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
        offsetY: -10,
      },
    ];
  }
  stopBubble(event) {
    event.stopPropagation();
  }
  openPopup(event: Event) {
    if (this.popupOverlayRef == null) {
      const position = this.overlay
        .position()
        .flexibleConnectedTo(this.inputElement)
        .withPositions(this.getPositions())
        .withViewportMargin(10)
        .withDefaultOffsetY(30);
      const config = new OverlayConfig({ positionStrategy: position, scrollStrategy: new BodyOverflowHiddenScrollStrategy() });
      this.popupOverlayRef = this.overlay.create(config);
      this.popupOverlayRef.overlayElement.addEventListener(
        'click',
        this.stopBubble
      );
      const filePreviewPortal = new ComponentPortal(
        AdDatePickerPopupComponent,
        null,
        this.createInjector({
          format: this.format,
          component: this,
          date: this.seletedDate,
          maxDate: typeof (this.maxDate) === "string" ? new Date(this.maxDate) : this.maxDate,
          minDate: typeof (this.minDate) === "string" ? new Date(this.minDate) : this.minDate
        })
      );
      this.popupOverlayRef.attach(filePreviewPortal);
      event.cancelBubble = true;
      event.stopPropagation();
    }
  }
  createInjector(dataToPass): PortalInjector {
    const injectorTokens = new WeakMap();
    injectorTokens.set(DATE_PICKER_CONFIG_DATA, dataToPass);
    return new PortalInjector(this.injector, injectorTokens);
  }
  //#endregion

  documentClickRemover;

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      this.addEventRemover(
        this.renderer2.listen(document, 'mousedown', (e: Event) => {
          if (
            this.popupOverlayRef !== undefined &&
            this.popupOverlayRef !== null
          ) {
            if (
              !(this.popupOverlayRef.overlayElement as any).contains(
                e.target
              ) &&
              !this.inputElement.nativeElement.contains(e.target)
            ) {
              this.closePopup();
              this.cd.detectChanges();
            }
          }
        })
      );
    });
  }

  ngOnDestroy(): void {
    if (this.documentClickRemover) {
      this.documentClickRemover();
    }
    this.runEventRemoverList();
  }

  openBtnClick(event: Event) {
    this.openPopup(event);
  }

  inputChange(event) {
    this.applyUserInputValue(this.inputText);
  }

  applyUserInputValue(inputValue: string) {
    const date = parse(inputValue, this.format, new Date(1900, 0, 1));
    if (format(this.seletedDate, this.format) !== format(date, this.format)) {
      if (!isNaN(date.getTime())) {
        this.seletedDate = date;
        this.emitChangeEvent(date);
      } else {
        // Invalid date
      }
    }
  }

  pickADate(date: Date) {
    this.seletedDate = date;
    this.emitChangeEvent(date);
  }

  emitChangeEvent(val: Date) {
    this.onChange.emit(val);
  }

  getFormattedDate() {
    if (this.seletedDate) {
      const f = this.format || 'yyyy/M/d';
      return format(this.seletedDate, this.format);
    } else {
      return '';
    }
  }

  closePopup() {
    if (this.popupOverlayRef) {
      this.popupOverlayRef.dispose();
    }
    this.popupOverlayRef = null;
  }
}
